import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { detectLanguage, loadLanguage } from './i18n/config'

// Load the page's language before the first render so it never flashes English.
loadLanguage(detectLanguage()).finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})

// Offline support for repeat visits; skipped in dev so Vite's HMR isn't cached.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Offline support is optional; ignore registration failures.
    });
  });
}
